import {
  setStore,
  getStore,
  removeStore,
} from '@/util/store'
import website from '@/config/website'

const common = {

  state: {
    language: getStore({ name: 'language' }) || 'en',
    isCollapse: false,
    isFullScren: false,
    isMenu: true,
    isShade: false,
    screen: -1,
    isLock: getStore({ name: 'isLock' }) || false,
    showTag: true,
    showDebug: true,
    showCollapse: true,
    showSearch: true,
    showLock: true,
    showFullScren: true,
    showTheme: true,
    showMenu: true,
    showColor: true,
    colorName: getStore({ name: 'colorName' }) || '#409EFF',
    themeName: getStore({ name: 'themeName' }) || 'theme-default',
    lockPasswd: getStore({ name: 'lockPasswd' }) || '',
    website,
    staticRouter: getStore({ name: 'staticRouter' }) || [],
    recentlyUser: getStore({ name: 'recentlyUser' }) || {},
  },
  actions: {
    // 保存静态路由
    setStaticRouter({ commit }, routers) {
      commit('SET_STATIC_ROUTER', routers)
    },
    // 设置语言
    setLanguage({ commit }, language) {
      commit('SET_LANGUAGE', language)
    },
  },
  mutations: {
    SET_STATIC_ROUTER(state, routers) {
      state.staticRouter = routers
      setStore({ name: 'staticRouter', content: state.staticRouter })
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language
      setStore({
        name: 'language',
        content: state.language,
      })
    },
    SET_SHADE: (state, active) => {
      state.isShade = active
    },
    SET_COLLAPSE: state => {
      state.isCollapse = !state.isCollapse
    },
    SET_FULLSCREN: state => {
      state.isFullScren = !state.isFullScren
    },
    SET_IS_MENU: (state, menu) => {
      state.isMenu = menu
    },
    SET_LOCK: state => {
      state.isLock = true
      setStore({
        name: 'isLock',
        content: state.isLock,
        type: 'session',
      })
    },
    SET_SCREEN: (state, screen) => {
      state.screen = screen
    },
    SET_COLOR_NAME: (state, colorName) => {
      state.colorName = colorName
      setStore({
        name: 'colorName',
        content: state.colorName,
      })
    },
    SET_THEME_NAME: (state, themeName) => {
      state.themeName = themeName
      setStore({
        name: 'themeName',
        content: state.themeName,
      })
    },
    SET_RECENTLY_USER: (state, recentlyUser) => {
      state.recentlyUser = recentlyUser
      setStore({
        name: 'recentlyUser',
        content: state.recentlyUser,
      })
    },
    SET_LOCK_PASSWD: (state, lockPasswd) => {
      state.lockPasswd = lockPasswd
      setStore({
        name: 'lockPasswd',
        content: state.lockPasswd,
        type: 'session',
      })
    },
    CLEAR_LOCK: state => {
      state.isLock = false
      state.lockPasswd = ''
      removeStore({
        name: 'lockPasswd',
        type: 'session',
      })
      removeStore({
        name: 'isLock',
        type: 'session',
      })
    },
  },
}
export default common
